import React from 'react';
import { Controller, type ControllerRenderProps } from 'react-hook-form';

import { Grid, InputCheckboxGroup } from '@companycam/slab-web';
import { translate } from 'translations/i18n';
import { type CreatePublicProfileParams } from 'data/v3/publicProfiles';
import { useGetTrustyIndustries } from 'data/v3/trusty';

import { type UseProfileFormReturn } from '../useProfileForm';
import { Loading } from '../CommonComponents';

type IndustriesProps = {
  formMethods: UseProfileFormReturn;
};

export const IndustriesField = ({ formMethods }: IndustriesProps) => {
  const industriesResponse = useGetTrustyIndustries();

  const selectedIndustries = formMethods.watch('industries') || [];
  const onIndustryChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: ControllerRenderProps<CreatePublicProfileParams, 'industries'>,
  ) => {
    if (e.target.checked) {
      field.onChange([e.target.value, ...field.value]);
    } else {
      field.onChange(field.value.filter((v) => v !== e.target.value));
    }
    formMethods.trigger('industries');
  };

  const industries = (industriesResponse.data?.data.industries || []).map(
    (industry) => ({
      value: `${industry.id}`,
      label: industry.name,
    }),
  );

  if (industriesResponse.isLoading) {
    return <Loading />;
  }

  return (
    <Grid
      id="industries"
      breakpoints={[{ cols: ['auto'], rowGap: 's', colGap: 'm' }]}
    >
      <Controller
        name="industries"
        control={formMethods.control}
        render={({ field, fieldState }) => (
          <InputCheckboxGroup
            selectedValues={selectedIndustries}
            id="industries"
            label={translate('portfolio.profile.industries')}
            options={industries}
            onChange={(event) => onIndustryChange(event, field)}
            status={fieldState.error ? 'error' : 'normal'}
            message={fieldState.error?.message}
            onBlur={field.onBlur}
          />
        )}
      />
    </Grid>
  );
};
